import React, { useEffect, useMemo } from 'react'
import styles from './magic-links.styles'
import injectSheet from 'react-jss'
import Auth from '../../auth/auth'
import Button from 'pobble-components/dist/button'
import duck from '../../images/su-duck.gif'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagic } from '@fortawesome/pro-solid-svg-icons/faMagic'
import Cookies from 'js-cookie'

const MagicLinks = ({
  ScreenToShow,
  params,
  initial,
  applyLink,
  action,
  classes
}) => {
  const visitedSignIn = useMemo(() => {
    return Cookies.get('VISITED_SIGNIN')
  }, [])

  useEffect(() => {
    !!visitedSignIn && applyLink()
  }, []) // eslint-disable-line

  return (
    <Auth>
      {initial &&
        !visitedSignIn && (
          <div className={classes.buttonHolder}>
            <img src={duck} alt="Duck" />
            <p>Please click to confirm you are a human!</p>
            <Button
              tall
              action={applyLink}
              icon={<FontAwesomeIcon icon={faMagic} />}>
              Click to confirm
            </Button>
          </div>
        )}
      {(!initial || !!visitedSignIn) &&
        ScreenToShow && <ScreenToShow params={params} />}
    </Auth>
  )
}

export default injectSheet(styles)(MagicLinks)
